export default __webpack_public_path__ + "static/media/Padron_ExecutiveOpen.b0216361.jpg";